var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visible,
            expression: "visible",
          },
        ],
        staticClass: "pop-right-click",
        style: { left: _vm.popoverLeft + "px", top: _vm.popoverTop + "px" },
        attrs: { width: "260" },
      },
      [
        _c("div", { staticClass: "menu-title" }, [
          _vm._v("五域订单号：" + _vm._s(_vm.item.orderNo)),
        ]),
        _c("div", { staticClass: "menu-list" }, [
          _vm.permission.includes("submitOrder")
            ? _c(
                "li",
                {
                  on: {
                    click: function ($event) {
                      return _vm.onEmit("onSubmitOrder")
                    },
                  },
                },
                [_vm._v("提交订单")]
              )
            : _vm._e(),
          _vm.permission.includes("resubmitOrder")
            ? _c(
                "li",
                {
                  on: {
                    click: function ($event) {
                      return _vm.onEmit("onResubmit")
                    },
                  },
                },
                [_vm._v("重新提交")]
              )
            : _vm._e(),
          _vm.permission.includes("modifyOrderAmount")
            ? _c(
                "li",
                {
                  on: {
                    click: function ($event) {
                      return _vm.onEmit("onGoodsAmount")
                    },
                  },
                },
                [_vm._v("修改下单金额")]
              )
            : _vm._e(),
          _vm.permission.includes("submitBonusApply")
            ? _c(
                "li",
                {
                  on: {
                    click: function ($event) {
                      return _vm.onEmit("onSubmitApply")
                    },
                  },
                },
                [_vm._v("发起提成申诉")]
              )
            : _vm._e(),
          _vm.permission.includes("getBonusApplyDetail")
            ? _c(
                "li",
                {
                  on: {
                    click: function ($event) {
                      return _vm.onEmit("onCheckApply")
                    },
                  },
                },
                [_vm._v("查看提成申诉")]
              )
            : _vm._e(),
          _vm.permission.includes("cancelBonusApply")
            ? _c(
                "li",
                {
                  on: {
                    click: function ($event) {
                      return _vm.onEmit("onRevokeApply")
                    },
                  },
                },
                [_vm._v("撤销申诉")]
              )
            : _vm._e(),
          _vm.permission.includes("directModifyBonus")
            ? _c(
                "li",
                {
                  on: {
                    click: function ($event) {
                      return _vm.onEmit("onSubmitApplyEdit")
                    },
                  },
                },
                [_vm._v("发起修改提成")]
              )
            : _vm._e(),
          _vm.permission.includes("auditBonusApply")
            ? _c(
                "li",
                {
                  on: {
                    click: function ($event) {
                      return _vm.onEmit("onConfirmModify")
                    },
                  },
                },
                [_vm._v("确认修改提成")]
              )
            : _vm._e(),
          _vm.permission.includes("confirmReceipt")
            ? _c(
                "li",
                {
                  on: {
                    click: function ($event) {
                      return _vm.onEmit("onConfirmReceipt")
                    },
                  },
                },
                [_vm._v("确认收货")]
              )
            : _vm._e(),
          _vm.permission.includes("cancelOrder")
            ? _c(
                "li",
                {
                  on: {
                    click: function ($event) {
                      return _vm.onEmit("onCancelOrder")
                    },
                  },
                },
                [_vm._v("取消订单")]
              )
            : _vm._e(),
          _vm.permission.includes("specifyExpress")
            ? _c(
                "li",
                {
                  on: {
                    click: function ($event) {
                      return _vm.onEmit("onSetExpress")
                    },
                  },
                },
                [_vm._v("指定快递")]
              )
            : _vm._e(),
          _vm.permission.includes("orderDetail")
            ? _c(
                "li",
                {
                  on: {
                    click: function ($event) {
                      return _vm.onEmit("onDetail")
                    },
                  },
                },
                [_vm._v("订单详情")]
              )
            : _vm._e(),
          _vm.permission.includes("setTag")
            ? _c(
                "li",
                {
                  on: {
                    click: function ($event) {
                      return _vm.onEmit("onSetTag")
                    },
                  },
                },
                [_vm._v("设置标签")]
              )
            : _vm._e(),
          _vm.permission.includes("specifyDeliveryDate")
            ? _c(
                "li",
                {
                  on: {
                    click: function ($event) {
                      return _vm.onEmit("onSetDate")
                    },
                  },
                },
                [_vm._v("指定发货日期")]
              )
            : _vm._e(),
          _vm.permission.includes("fixMissingProductCode")
            ? _c(
                "li",
                {
                  on: {
                    click: function ($event) {
                      return _vm.onEmit("onGoodsInfoEdit")
                    },
                  },
                },
                [_vm._v("修复商品编码缺失")]
              )
            : _vm._e(),
          _vm.permission.includes("customerServiceRemark")
            ? _c(
                "li",
                {
                  on: {
                    click: function ($event) {
                      return _vm.onEmit("onSetRemark")
                    },
                  },
                },
                [_vm._v("客服备注")]
              )
            : _vm._e(),
          _vm.permission.includes("orderOperationRecord")
            ? _c(
                "li",
                {
                  on: {
                    click: function ($event) {
                      return _vm.onEmit("onOrderRecord")
                    },
                  },
                },
                [_vm._v("订单操作记录")]
              )
            : _vm._e(),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }